<template>
  <span>
    <v-card class="mb-0 mt-n2 parametros-v-card elevation-0">
      <v-row justify="start" class="mx-3 mt-0">
        <v-col class="pb-0" cols="12" sm="6" md="4">
          <div class="text-h6 grey--text mb-2 ml-4 body-2">
            Municípios Prioritários
          </div>
          <v-select
            class="pl-4"
            :items="[
              { text: 'PLNA', value: 'plna' },
              { text: 'PSFPg', value: 'psfpg' }
            ]"
            v-model="municipioPrioritario"
            clearable
            outlined
            dense
          />
        </v-col>
        <v-col class="pb-0" cols="12" sm="6" md="4">
          <div class="text-h6 grey--text mb-2 ml-4 body-2">
            Regional selecionada
          </div>
          <v-select
            class="pl-4"
            :items="regionaisList"
            :value="regionalSelecionada"
            @change="setRegionalSelecionada"
            outlined
            dense
            />
        </v-col>
        <v-col class="pb-0" cols="12" sm="6" md="4">
          <div class="text-h6 grey--text mb-2 ml-4 body-2">
            Município selecionado
          </div>
          <v-autocomplete
            class="pl-4"
            :items="listaMunicipios"
            v-model="municipioSelecionado"
            clearable
            outlined
            dense
          />
        </v-col>
      </v-row>
    </v-card>

    <v-row dense justify="center">
      <v-col cols="12" md="9" class="flex-md-grow-1">
        <v-card class="my-1 elevation-0">
          <v-card-text>
            <kpis-by-municipio-data-table
              :traducaoIndicadores="traducaoIndicadores"
              :dados="dadosPorMunicipio"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="auto" class="flex-md-grow-1">
        <v-card class="my-1 elevation-0">
          <v-card-text>
            <kpis-by-municipio-map
              :kpis="kpis"
              :dadosPorMunicipio="dadosPorMunicipio"
              :metasKpis="metasKpis"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>


    <v-spacer class="mt-10" />
    <v-row justify="center" v-if="municipioSelecionado">
      <v-col cols="auto">
        <h3>Município Selecionado: {{ municipioSelecionadoText }}</h3>
      </v-col>
    </v-row>
    <v-row dense justify="center">  
      <v-col v-for="indicador in kpis" :key="indicador" cols="12" md="6">
        <v-card class="my-1 elevation-0">
          <v-card-title>
            <v-tooltip
              v-if="traducaoIndicadores[indicador] != undefined"
              bottom
            >
              <template v-slot:activator="{ on }">
                <h5 v-on="on">
                  {{ indicador.replaceAll("_", " ") | toUpperCase }}
                </h5>
              </template>
              <span>{{ traducaoIndicadores[indicador] }}</span>
            </v-tooltip>
            <h5 v-else>
              {{ indicador.replaceAll("_", " ") | toUpperCase }}
            </h5>
          </v-card-title>
          <v-card-text>
            <column-chart-mensal
              :dadosMensais="dadosPorCompetencia"
              :categories="categories"
              :indicador="indicador"
              :metasKpis="municipioSelecionado ? metasKpisMunicipios[municipioSelecionado] || {} : metasKpis"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </span>
</template>

<script>
  import DashboardNivelTensaoService from "@/services/DashboardNivelTensaoService";
  import MunicipiosService from "@/services/MunicipiosService";

  import { mapState, mapActions } from "vuex";

  export default {
    name: "DashboardNivelTensaoVisaoMunicipios",
    components: {
      KpisByMunicipioDataTable: () =>
        import(
          "@/components/dashboardNivelTensao/KpisByMunicipioDataTable.vue"
        ),
      KpisByMunicipioMap: () =>
        import("@/components/dashboardNivelTensao/KpisByMunicipioMap.vue"),
      ColumnChartMensal: () =>
        import(
          "@/components/dashboardNivelTensao/charts/ColumnChartMensal.vue"
        ),
    },
    props: {
      competenciaDe: {
        type: String,
        required: true,
      },
      competenciaAte: {
        type: String,
        required: true,
      },
      inspecoesSelecionadas: {
        type: Array,
        required: true,
      },
      medicoesSelecionadas: {
        type: Array,
        required: true,
      },
      origemMedicoesSelecionadas: {
        type: Array,
        required: true,
      },
      tensaoReferenciaSelecionadas: {
        type: Array,
        required: true,
      },
      categories: {
        type: Array,
        required: true,
      },
      activatedTab: {
        type: Number,
        required: true,
      },
      traducaoIndicadores: {
        type: Object,
        default: {},
      },
      metasKpis: {
        type: Object,
        required: true,
      }
    },
    data: () => ({
      kpis: [
        "plna",
        "qrt",
        "drpe",
        "drce",
        "prp",
        "psfpt_crp",
        "psfpt_cri",
        "psfpt_rmp",
        "psfpt_rmc",
        "psfpg",
        "icnt",
        "irnt",
        "total_compensacao",
        "qtd_reclamacoes_totais",
      ],
      regionais: [],
      listaMunicipios: [],
      dadosPorMunicipio: [],
      dadosPorCompetencia: {},
      metasKpisMunicipios: {},
      municipioPrioritario: null,
    }),
    computed: {
      ...mapState('parametrosDashboardNivelTensao', [
        'regionalSelecionada',
        'municipio'
      ]),
      municipioSelecionado: {
        get() {
          return this.municipio;
        },
        set(newValue) {
          this.setMunicipio(newValue);
        }
      },
      regionaisList() {
        return this.regionais.map((el) => el.nome);
      },
      regionalSelecionadaId() {
        let regional = this.regionais.find(
          (element) => element.nome == this.regionalSelecionada
        );
        return regional == undefined ? 0 : regional.id;
      },
      municipioSelecionadoText() {
        return this.listaMunicipios.find(mun => mun.value === this.municipioSelecionado)?.text;
      },  
    },
    async mounted() {
      this.getRegionais();
      await this.getMetasKpisByMunicipio();

      this.getDados();
    },
    methods: {
      ...mapActions('parametrosDashboardNivelTensao', [
        'setRegionalSelecionada',
        'setMunicipio'
      ]),
      getRegionais() {
        return MunicipiosService.getRegionais()
          .then((res) => {
            this.regionais = res;
            if (this.regionalSelecionada == null) {
              this.setRegionalSelecionada(res.find(
                (el) => el.nome.toLowerCase() == "distribuidora"
              ).nome);
            }
          })
          .catch((err) => {
            throw err;
          });
      },
      getDados() {
        // Apenas atualizado os dados se for a visao selecionada
        if (this.activatedTab !== 2) return;

        this.$emit("updateLoadingDados", true);

        Promise.all([
          this.getDadosPorMunicipio(),
          this.getDadosPorCompetencia(),
        ])
          .catch((err) => {
            console.error(err);
            this.$toast.error("Erro recuperar dados.", "", {
              position: "topRight",
            });
          })
          .finally(() => this.$emit("updateLoadingDados", false));
      },
      getDadosPorMunicipio() {
        return DashboardNivelTensaoService.getDadosIndicadoresPorMunicipio(
          this.competenciaDe,
          this.competenciaAte,
          this.regionalSelecionadaId,
          this.inspecoesSelecionadas.join(","),
          this.medicoesSelecionadas.join(","),
          this.origemMedicoesSelecionadas.join(","),
          this.tensaoReferenciaSelecionadas.join(","),
          this.municipioPrioritario
        )
          .then((res) => {
            this.dadosPorMunicipio = res;

            this.listaMunicipios = this.dadosPorMunicipio
              .map((el) => {
                return {
                  text: el.nome_municipio,
                  value: el.codigo_municipio
                }
              })
              .sort((a, b) => Number(a ?? 0) - Number(b ?? 0));
          })
          .catch((err) => {
            throw err;
          });
      },
      getDadosPorCompetencia() {
        return DashboardNivelTensaoService.getDadosIndicadoresMensais(
          this.competenciaDe,
          this.competenciaAte,
          this.regionalSelecionadaId,
          this.municipioSelecionado,
          this.inspecoesSelecionadas.join(","),
          this.medicoesSelecionadas.join(","),
          this.origemMedicoesSelecionadas.join(","),
          this.tensaoReferenciaSelecionadas.join(","),
          this.municipioPrioritario
        )
          .then((res) => {
            this.dadosPorCompetencia = res;
          })
          .catch((err) => {
            throw err;
          });
      },
      getMetasKpisByMunicipio() {
        return DashboardNivelTensaoService.getMetasKpisMunicipios(
          this.competenciaDe,
          this.competenciaAte,
          this.regionalSelecionadaId
        )
          .then(response => {
            this.metasKpisMunicipios = response;
          })
          .catch(err => {
            throw err;
          });
      },
    },
    watch: {
      activatedTab() {
        this.getDados();
      },
      competenciaDe() {
        this.getDados();
        this.getMetasKpisByMunicipio();
      },
      competenciaAte() {
        this.getDados();
        this.getMetasKpisByMunicipio();
      },
      regionalSelecionada() {
        this.getDados();
        this.getMetasKpisByMunicipio();
        this.setMunicipio(null);
      },
      municipioSelecionado() {
        this.getDadosPorCompetencia();
      },
      municipioPrioritario() {
        this.getDados();
        this.setMunicipio(null);
      },
    },
  };
</script>

<style>
  .parametros-v-card {
    box-shadow: 0px 0px 0px !important;
  }
</style>
